// import React, { useEffect, useState } from 'react'
// import client from '../API/API';
// import { Center, Flex, Group, SegmentedControl, Title } from '@mantine/core';
// import AccordianComponent from '../components/accordian/AccordianComponent';
// import LoaderComponent from '../components/loader/LoaderComponent';
// import { fullDate } from '../utils/reusedfunctions';
// import { MdFormatListBulleted } from 'react-icons/md'
// import { AiFillAppstore } from 'react-icons/ai'
// import NoDataAvailable from '../components/noDataAvailable/NoDataAvailable';
// import DigitalDataCard from '../components/cards/DigitalDataCard';
// import AnalogDataCard from '../components/cards/AnalogDataCard';

// const StatusMachines = (props) =>
// {
//     const { nodeid, machineid } = props;
//     const [timeStamp, setTimestamp] = useState("");
//     const [statusData, setStatusData] = useState({})
//     const [length, setLenght] = useState(0)
//     const [value, setValue] = useState('list')

//     // useEffect(() =>
//     // {
//     //     if (nodeid !== "")
//     //     {
//     //         client.get('/Machines_sub_details/', {
//     //             withCredentials: true,
//     //             params: {
//     //                 node_id: nodeid,
//     //                 // machine_id: nodeid,
//     //                 // module: "iostatus"
//     //                 module: "7"
//     //             },

//     //         }).then(async (response) =>
//     //         {

//     //             var globalresponse = response.data.iostatus
//     //             const dbtime = response.data.iostatus.time_stamp
//     //             const stringWithoutQuotes = dbtime.replace(/['"]/g, "");
//     //             const stringWithSpace = stringWithoutQuotes.replace(/T/, " ");
//     //             const stringWithoutDecimal = stringWithSpace.substring(0, 19);
//     //             const stringWithNewDate = stringWithoutDecimal.replace(/2023-10-04/, "04-10-2023");
//     //             setTimestamp(stringWithNewDate)

//     //             // console.log('Io status : ' + JSON.stringify(extractedData))
//     //             const { machine_id, machine_name, time_stamp, node_id, ...rest } = globalresponse
//     //             console.log(rest);
//     //             setStatusData(rest)

//     //         }).catch((error) =>
//     //         {
//     //             console.log(error);
//     //         });
//     //     }


//     // }, [nodeid]);
//     useEffect(() =>
//     {
//         setStatusData({})
//         let baseurl = `ws://192.168.29.132:8000/machine_mqtt_data/?machine_id=${machineid}`
//         const socket = new WebSocket(baseurl)

//       socket.onopen = () => {
//     console.log("WebSocket connected");

//     // ✅ SEND ONLY AFTER CONNECT
//     socket.send(JSON.stringify({
//       action: "subscribe",
//       machine_id: machineid
//     }));
//   };


//         // socket.onmessage = (event) =>
//         // {
//         //     const websocketdata = JSON.parse(event.data)
//         //     const data = websocketdata.iostatus
//         //     console.log("io data : " + JSON.stringify(websocketdata))

//         //     // const { machine_id, machine_name, Timestamp, node_id, ...rest } = data
//         //     // console.log(rest);

//         //     const length = [...rest.analog_input, ...rest.analog_output, ...rest.digital_input, ...rest.digital_output, ...rest.others]
//         //     // console.log("length of status" + length.length);
//         //     setLenght(length.length)
//         //     setStatusData(rest)
//         //     setTimestamp(Timestamp)
//         // }
        
//      socket.onmessage = (event) => {
//   const websocketdata = JSON.parse(event.data);
//   const data = websocketdata.iostatus;
//   if (!data) return;

//   const cleanedData = {
//     analog_input: data.analog_input || [],
//     analog_output: data.analog_output || [],
//     digital_input: data.digital_input || [],
//     digital_output: data.digital_output || [],
//     others: data.others || []
//   };

//   const inputs = Object.values(cleanedData).flat();

//   setLenght(inputs.length);
//   setStatusData(cleanedData);
//   setTimestamp(data.timestamp || "");
// };


//         socket.onclose = (event) =>
//         {
//             // if (ev) {

//             // }
//             socket.onopen = (event) =>
//             {
//                 console.log('WebSocket connection established again after closed :', event);

//             }
//         }
//         return () =>
//         {
//             if (socket)
//             {
//                 console.log('WebSocket connection closed: close event');
//                 socket.close()

//             }
//         }


//     }, [machineid])
//     const hasData = Object.values(statusData).some(
//   (arr) => Array.isArray(arr) && arr.length > 0
// );



//     return (

//         <div>
// {hasData ? (
//   <>
//     <Group position='apart'>
//       <Title fw={500} fz={16} p={'1rem'}>
//         Last updated at: {fullDate(timeStamp)}
//       </Title>

//       <SegmentedControl
//         mr={"1rem"}
//         onChange={setValue}
//         data={[
//           { value: 'list', label: <MdFormatListBulleted /> },
//           { value: 'expand', label: <AiFillAppstore /> }
//         ]}
//       />
//     </Group>
//   </>
// ) : (
//   <LoaderComponent />
// )}


//             {
//                 value === 'list' ? (
//                     <AccordianComponent data={statusData} />
//                 ) : (
//                     <Flex direction={"column"} gap={"xl"}>
//                         <Group >
//                             {Object.entries(statusData).map(([key, value]) => (
//                                 (key === "digital_input" || key === "digital_output") && (
//                                     value.map((card) => (
//                                         <DigitalDataCard key={card.name} data={card} />
//                                     ))
//                                 )
//                             ))}
//                         </Group>

//                         <Group >
//                             {Object.entries(statusData).map(([key, value]) => (
//                                 !(key === "digital_input" || key === "digital_output") && (
//                                     value.map((card) => (
//                                         <AnalogDataCard key={card.name} data={card} />
//                                     ))
//                                 )
//                             ))}
//                         </Group>
//                     </Flex>
//                 )
//             }

//         </div>

//     )
//     // return (

//     //     <div>

//     //         {length > 0 ? <>
//     //             <Title fw={500} fz={16} p={'1rem'} ml={'0rem'} color='var(--color-onclick)'>Last updated at: {fullDate(timeStamp)} </Title>

//     //             <AccordianComponent data={statusData} /></> : <LoaderComponent />


//     //             }
//     //     </div>

//     // )
// }

// export default StatusMachines
import React, { useEffect, useState } from 'react';
import { Center, Flex, Group, SegmentedControl, Title } from '@mantine/core';
import { MdFormatListBulleted } from 'react-icons/md';
import { AiFillAppstore } from 'react-icons/ai';

import AccordianComponent from '../components/accordian/AccordianComponent';
import LoaderComponent from '../components/loader/LoaderComponent';
import DigitalDataCard from '../components/cards/DigitalDataCard';
import AnalogDataCard from '../components/cards/AnalogDataCard';
import { fullDate } from '../utils/reusedfunctions';
import NoDataAvailable from '../components/noDataAvailable/NoDataAvailable';

   

const StatusMachines = ({ machineid, statusChannels = [] }) => {
  const [statusData, setStatusData] = useState({});
  const [timeStamp, setTimestamp] = useState('');
  const [view, setView] = useState('list');
  const [isWaiting, setIsWaiting] = useState(true);


 useEffect(() => {
     console.log("MACHINE ID =", machineid);
      if (!machineid) {
        setIsWaiting(false);
        return;
      }
    
    setStatusData({});
    setTimestamp('');
    setIsWaiting(true);

    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const userId = window.localStorage.getItem('userid') || '';
    const socket = new WebSocket(
      `${wsProtocol}//${window.location.host}/mqttData/?machine_id=${machineid}&user_id=${userId}`
    );
    const noDataTimer = setTimeout(() => {
      setIsWaiting(false);
    }, 2500);

    

    
  

  
  socket.onopen = () => {
      console.log('Status WS connected');
      setTimeout(() => {
      socket.send(
        JSON.stringify({
          action: 'subscribe',
          machine_id: machineid ,
        })
      );
    }, 1000);
    };

   

    socket.onclose = () => {
      console.log('Status WS closed');
      setIsWaiting(false);
    };

    socket.onerror = (err) => {
      console.error('Status WS error', err);
      setIsWaiting(false);
    };

 

   
     socket.onmessage = (event) => {
      const wsData = JSON.parse(event.data);
      const data = wsData.payload;
      if (!data) return;

      let cleanedData = {
        analog_input:  data.analog_inputs  || [],
        analog_output: data.analog_outputs || [],
        digital_input: data.digital_inputs  || [],
        digital_output: data.digital_outputs || [],
        others:        data.other           || [],
      };

      // Filter to status_channels if configured
      if (statusChannels && statusChannels.length > 0) {
        const allowed = new Set(statusChannels);
        cleanedData = {
          analog_input:  cleanedData.analog_input.filter(ch  => allowed.has(ch.name)),
          analog_output: cleanedData.analog_output.filter(ch => allowed.has(ch.name)),
          digital_input: cleanedData.digital_input.filter(ch => allowed.has(ch.name)),
          digital_output: cleanedData.digital_output.filter(ch => allowed.has(ch.name)),
          others:        cleanedData.others.filter(ch        => allowed.has(ch.name)),
        };
      }

      setStatusData(cleanedData);
      setTimestamp(data.timestamp || data.Timestamp || '');
      setIsWaiting(false);
    };

    return () => {
      clearTimeout(noDataTimer);
      socket.close();
    };
  }, [machineid]);
  

  const hasData = Object.values(statusData).some(
    (arr) => Array.isArray(arr) && arr.length > 0
  );

  return (
    <div>
      {hasData ? (
        <>
          {/* HEADER */}
          <Group position="apart">
            <Title fw={500} fz={16} p="1rem">
              Last updated at: {fullDate(timeStamp)}
            </Title>

            <SegmentedControl
              mr="1rem"
              value={view}
              onChange={setView}
              data={[
                {
                  value: 'list',
                  label: (
                    <Center>
                      <MdFormatListBulleted />
                    </Center>
                  ),
                },
                {
                  value: 'expand',
                  label: (
                    <Center>
                      <AiFillAppstore />
                    </Center>
                  ),
                },
              ]}
            />
          </Group>

          {/* CONTENT */}
          {view === 'list' ? (
            <AccordianComponent data={statusData} />
          ) : (
            <Flex direction="column" gap="xl">
              <Group>
                {Object.entries(statusData).map(
                  ([key, val]) =>
                    (key === 'digital_input' ||
                      key === 'digital_output') &&
                    val.map((card) => (
                      <DigitalDataCard key={card.name} data={card} />
                    ))
                )}
              </Group>

              <Group>
                {Object.entries(statusData).map(
                  ([key, val]) =>
                    key !== 'digital_input' &&
                    key !== 'digital_output' &&
                    val.map((card) => (
                      <AnalogDataCard key={card.name} data={card} />
                    ))
                )}
              </Group>
            </Flex>
          )}
        </>
      ) : isWaiting ? (
        <LoaderComponent />
      ) : (
        <NoDataAvailable />
      )}
    </div>
  );
};

export default StatusMachines;
